import React from 'react'
import {sortBy} from 'lodash'
import BootstrapTable from 'react-bootstrap-table-next'
import { saveAs } from 'file-saver'
import { Button, ButtonToolbar } from 'react-bootstrap'
import paginationFactory from 'react-bootstrap-table2-paginator'

import Topbar from '../Topbar'
import DeleteScanModal from './modal/deleteScan'
import DownloadModal from '../../components/DownloadModal'
import Score from '../../components/Score'

import * as scansService from '../../services/scan-service'

export default class Scans extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.buttonFormatter = this.buttonFormatter.bind(this)

    this.state = {
      scans: []
    }
  }

  getScans() {
    scansService.getScans().then(scans => {
      this.setState({ scans: scans })
    })
  }

  exportScans() {
    scansService.exportScans().then(x => this.save(x, 'Scans.xlsx'))
  }

  save(result, filename) {
    let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, filename)
  }

  componentDidMount() {
    this.getScans()
  }

  buttonFormatter(cell, row, id) {
    return (
      <div className="row-actions">
        <Button
          className="edit-scan-entry action-btn"
          onClick={() => {
            this.props.history.push(`/scans/${row.id}`)
          }}
        />
        <Button className="view-entry action-btn" onClick={() => this.props.history.push(`/results/${row.id}`)} />
        <DeleteScanModal reload={() => this.getScans()} info={row} />
      </div>
    )
  }

  render() {
    const { scans } = this.state

    function headerFormatter(column, colIndex, { sortElement }) {
      return (
        <span className="sortable-inner">
          <span className="text">{column.text}</span>
          {sortElement}
        </span>
      )
    }

    function contentFormatter(cell, row) {
      return <span className="text">{cell}</span>
    }

    function scoreFormatter(cell, row) {
      return (
        <span className="text">
          <Score score={cell} />
        </span>
      )
    }

    const columns = [
      {
        dataField: 'locationName',
        text: 'Locatie',
        sort: true,
        headerFormatter: headerFormatter,
        formatter: contentFormatter
      },
      {
        dataField: 'organizationalUnitName',
        text: 'Organisatorische eenheid',
        sort: true,
        headerFormatter: headerFormatter,
        formatter: contentFormatter
      },
      {
        dataField: 'consultationDate',
        text: 'Raadpleging',
        sort: true,
        headerFormatter: headerFormatter,
        formatter: contentFormatter
      },
      {
        dataField: 'completedDate',
        text: 'Scan voltooid',
        sort: true,
        headerFormatter: headerFormatter,
        formatter: contentFormatter
      },
      {
        dataField: 'totalScore',
        text: 'Score',
        sort: true,
        headerFormatter: headerFormatter,
        formatter: scoreFormatter
      },
      {
        dataField: 'button',
        text: ' ',
        formatter: this.buttonFormatter
      }
    ]

    const paginationOptions = paginationFactory({
      sizePerPageList: [{
        value: 20
      }],
      paginationSize: 5,
      hideSizePerPage: true,
      alwaysShowAllBtns: true
    })

    return (
      <div className="content table-page scans">
        <div className="content-inner">
          <Topbar title="Scans" />

          <div className="inner">
            <div className="table-actions">
              <ButtonToolbar>
              <DownloadModal
                  text="Wilt u de gegevens van alle scans downloaden als .csv-bestand? Hiermee kunt u in andere software (bijvoorbeeld Excel) een nadere analyse verrichten."
                  title="Exporteer alle scans"
                  textbtn="Exporteer .csv"
                  modalbtntext= "Exporteer"
                  export={() => this.exportScans()}/>
              </ButtonToolbar>
            </div>

            <BootstrapTable
              keyField="id"
              data={sortBy(scans, ["completedDate", "locationName", "organizationalName"])}
              columns={columns}
              bordered={false}
              striped
              hover
              condensed
              pagination={paginationOptions}
            />
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/ScanOverview/index.js